import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { DBImportType } from '@/types/import';
import { EndpointResponse } from '@/types/endpoints';
import { utils } from '@/utils';
import type { WriteRequestOptions } from '../requestOptions';

const validate = (importType: string) => {
  if (!importType) {
    throw new Error('`importType` is required');
  }
};

type RequestParams = {
  importType: DBImportType;
  profileId?: number;
  data?: Record<string, unknown>;
};

type Response = {
  id: number;
  message?: string;
};

export const createImport = async (
  scope: RequestScope,
  { importType, profileId, data = {} }: RequestParams,
  requestOptions: WriteRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    validate(importType);

    const profileQuery = profileId && profileId !== -1 ? `?profile=${profileId}` : '';
    const url = `${importType}/import${profileQuery}`;

    const result = await scopedApi(scope).post<EndpointResponse<Response>>(url, data, requestOptions);

    return result.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
